<h5 class="footer-contacts__title">{{ 'HEADER_CONTACT_US'|translate }}</h5>

<div class="footer-contacts__text">{{ 'TEXT_CONTACT_US_MESSAGE'|translate }}</div>

<address class="footer-contacts__contacts" *ngIf="data">
    <dl>
        <dt>{{ 'TEXT_PHONE_NUMBER'|translate }}</dt>
        <dd *ngFor="let item of theme.contacts.phone">{{data.primary_phone_no}}</dd>
    </dl>
    <dl>
        <dt>Secondary Phone Number</dt>
        <dd *ngFor="let item of theme.contacts.phone">{{data.secondary_phone_no}}</dd>
    </dl>
    <dl>
        <dt>{{ 'TEXT_EMAIL_ADDRESS'|translate }}</dt>
        <dd *ngFor="let item of theme.contacts.email">{{data.email}}</dd>
    </dl>
    <dl>
        <dt>{{ 'TEXT_OUR_LOCATION'|translate }}</dt>
        <dd *ngFor="let item of theme.contacts.address">{{data.address}}</dd>
    </dl>

</address>
